import { Box, FormField } from '@zillow/constellation-10';
import { AdornedInput, IconChevronDown } from '@zillow/constellation';
import { Col, Row } from '@zg-rentals/zrs-comet';
import { StyledSkeleton, StyledSkeletonAdornment, StyledSkeletonInput } from './StyledComponents';
import Bone from '../Bone';
import SkeletonContainer from '../SkeletonContainer';
import { forwardRef } from 'react';
import { formFieldStyles } from '.';

export const PropertyDropdownSkeleton = () => {
  return (
    <FormField
      css={formFieldStyles}
      control={
        <AdornedInput
          input={
            <StyledSkeletonInput disabled={true} placeholder="Enter a property" paddingTop={1.8} paddingBottom={1.8} />
          }
          rightAdornment={
            <StyledSkeletonAdornment>
              <IconChevronDown />
            </StyledSkeletonAdornment>
          }
        />
      }
    />
  );
};

export const Skeleton = forwardRef<HTMLDivElement>((_, ref) => (
  <SkeletonContainer ref={ref}>
    <StyledSkeleton>
      <Bone dark={true} type="line" />
    </StyledSkeleton>
  </SkeletonContainer>
));

export const SkeletonListItem = forwardRef<HTMLDivElement>((_, ref) => (
  <SkeletonContainer ref={ref}>
    <Box css={{ margin: 'default' }}>
      <Row hidden={[]}>
        <Col xs={8}>
          <Bone dark={true} />
        </Col>
      </Row>

      <Row hidden={[]} margin={1}>
        <Col xs={10}>
          <Bone dark={true} />
        </Col>
      </Row>
    </Box>
  </SkeletonContainer>
));
